import * as React from "react";
import { useState } from "react";
import { Formik, Form, useFormikContext } from "formik";
import { Alert, BootstrapModalWrapper, Modal } from "components/bootstrap";
import ModalSubmit from "components/common/ModalSubmit";
const CreateModalContent = ({ entityName, onCancel, submitError, children }) => {
  const { isSubmitting, isValidating, isValid } = useFormikContext();
  const entityNameLower = entityName.toLowerCase();
  return /* @__PURE__ */ React.createElement(Form, { className: "form form-horizontal" }, /* @__PURE__ */ React.createElement(Modal.Header, null, /* @__PURE__ */ React.createElement(Modal.Title, null, "Create ", entityName)), /* @__PURE__ */ React.createElement(Modal.Body, null, /* @__PURE__ */ React.createElement("div", { className: "container-fluid" }, children, submitError && /* @__PURE__ */ React.createElement(Alert, { bsStyle: "danger", title: "Failed to save" }, submitError))), /* @__PURE__ */ React.createElement(Modal.Footer, null, /* @__PURE__ */ React.createElement(
    ModalSubmit,
    {
      submitButtonText: `Create ${entityNameLower}`,
      submitLoadingText: `Creating ${entityNameLower}...`,
      isSubmitting,
      isAsyncSubmit: true,
      disabledSubmit: !isValid || isValidating,
      onCancel
    }
  )));
};
const CreateModal = ({
  entityName,
  show,
  onClose,
  initialValues,
  onSubmit,
  validate = void 0,
  children
}) => {
  const [submitError, setSubmitError] = useState(null);
  const handleSubmit = async (values) => {
    var _a;
    setSubmitError(null);
    try {
      await onSubmit(values);
      onClose();
    } catch (error) {
      setSubmitError((_a = error == null ? void 0 : error.message) != null ? _a : "An error occurred. Please try again.");
    }
  };
  return /* @__PURE__ */ React.createElement(BootstrapModalWrapper, { showModal: show, onHide: onClose }, /* @__PURE__ */ React.createElement(Formik, { initialValues, onSubmit: handleSubmit, validate, validateOnBlur: false }, /* @__PURE__ */ React.createElement(CreateModalContent, { entityName, onCancel: onClose, submitError }, children)));
};
export default CreateModal;
